import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    standalone: false,
    selector: 'app-filter',
    templateUrl: './filter.component.html',
    styleUrls: ['./filter.component.scss']
})
export class FilterComponent {
    @Input() filterValue = '';
    @Input() placeholder = 'Filter';

    @Output() filterValueChange = new EventEmitter<string>();

    clear() {
        this.filterValue = '';
        this.filterValueChange.emit(this.filterValue);
    }
}
